"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLoggerConf = exports.Logger = exports.initCustomLogger = void 0;
/* tslint:disable */
/* eslint:disable */
/**
* @typedef {string} Url
*/
/**
* @typedef {string} GUID
*/
/**
* @typedef {number} DateTime
*/
var dummy;
var defaultConfig = { endpoint: 'wixboost-ugc' };
var init = function (webOrMobileLogger) { return function (userConfig) {
    if (userConfig === void 0) { userConfig = {}; }
    var defaults = userConfig.defaults, restOfConfig = __rest(userConfig, ["defaults"]);
    var config = __assign(__assign({}, defaultConfig), restOfConfig);
    var factoryInstance = typeof webOrMobileLogger.factory === 'function' ? webOrMobileLogger.factory(config) : webOrMobileLogger;
    var logger = getLogger(factoryInstance);
    return defaults ? logger.util.updateDefaults(defaults) : logger;
}; };
exports.initCustomLogger = function (factoryInstance) { return getLogger(factoryInstance); };
var getLogger = function (biLoggerClientFactoryInstance) {
    return new Logger(biLoggerClientFactoryInstance);
};
var Logger = /** @class */ (function () {
    function Logger(biLoggerClientFactoryInstance) {
        var _this = this;
        this.biLoggerClientFactoryInstance = biLoggerClientFactoryInstance;
        this.util = {
            updateDefaults: function (defaults) {
                _this.biLoggerClientFactoryInstance.updateDefaults(defaults);
                return _this;
            },
            log: function (logParams, context) {
                return _this.bi.log(logParams, context);
            }
        };
        biLoggerClientFactoryInstance
            .updateDefaults({ src: 16 });
        this.bi = biLoggerClientFactoryInstance.logger({ endpoint: 'wixboost-ugc' });
    }
    ;
    /**
    * @typedef {Object} bookingsPaymentsPaymentMethodPopupChooseOfflineParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {GUID} biToken - null
    * @property {string} serviceId - -
    * @property {string} type - {class\ind}
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings > payments>payment method popup>choose offline. Evid: 555.
     * Event description: http://prntscr.com/ehwro8.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * biToken - Type: guid.
     *
     * serviceId - Type: string. Desc: -
     *
     * type - Type: string. Desc: {class\ind}
     *
     * visitor_id - Type: guid.
     * @param {bookingsPaymentsPaymentMethodPopupChooseOfflineParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsPaymentsPaymentMethodPopupChooseOffline = function (params) {
        return this.bi.log(__assign({ evid: 555 }, params));
    };
    /**
    * @typedef {Object} bookingsOneAppApplyPromoCodeParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - business_id
    * @property {GUID} contactId - null
    * @property {GUID} couponId - coupon_id
    * @property {boolean} isEdited - 0 if the user enters the code for the first time, 1 if it is edited
    * @property {GUID} biToken - msid
    * @property {string} type - service type {class\ind\course}
    * @property {string} validValue - {ok/expired/invalid}
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Bookings --> OneApp --> Apply promo code. Evid: 575.
     * Event description: Apply promo code after entering it/click "Save".
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid. Desc: business_id
     *
     * contactId - Type: guid.
     *
     * couponId - Type: guid. Desc: coupon_id
     *
     * isEdited - Type: bool. Desc: 0 if the user enters the code for the first time, 1 if it is edited
     *
     * biToken - Type: guid. Desc: msid
     *
     * type - Type: string. Desc: service type {class\ind\course}
     *
     * validValue - Type: string. Desc: {ok/expired/invalid}
     *
     * visitor_id - Type: guid.
     * @param {bookingsOneAppApplyPromoCodeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsOneAppApplyPromoCode = function (params) {
        return this.bi.log(__assign({ evid: 575 }, params));
    };
    /**
    * @typedef {Object} bookingsDeletePromoCodeParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - business_id
    * @property {GUID} contactId - contact_id
    * @property {boolean} is_over_editor - -
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - is_preview
    * @property {GUID} biToken - msid
    * @property {string} type - service type {class\ind\course}
    * @property {GUID} visitor_id - visitor id
    **/
    /**
     * Name: bookings > delete promo code. Evid: 573.
     * Event description: Delete promo code - click on the garbage icon.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid. Desc: business_id
     *
     * contactId - Type: guid. Desc: contact_id
     *
     * is_over_editor - Type: bool. Desc: -
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool. Desc: is_preview
     *
     * biToken - Type: guid. Desc: msid
     *
     * type - Type: string. Desc: service type {class\ind\course}
     *
     * visitor_id - Type: guid. Desc: visitor id
     * @param {bookingsDeletePromoCodeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsDeletePromoCode = function (params) {
        return this.bi.log(__assign({ evid: 573 }, params));
    };
    /**
    * @typedef {Object} bookingsClickOnEnterPromoCodeParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - business_id
    * @property {GUID} contactId - contact_id
    * @property {boolean} is_over_editor - -
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - is_preview
    * @property {GUID} biToken - msid
    * @property {string} type - {class\ind\course}
    * @property {GUID} visitor_id - visitor id
    **/
    /**
     * Name: bookings > click on "enter promo code". Evid: 571.
     * Event description: Click on enter promo code from contact info page.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid. Desc: business_id
     *
     * contactId - Type: guid. Desc: contact_id
     *
     * is_over_editor - Type: bool. Desc: -
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool. Desc: is_preview
     *
     * biToken - Type: guid. Desc: msid
     *
     * type - Type: string. Desc: {class\ind\course}
     *
     * visitor_id - Type: guid. Desc: visitor id
     * @param {bookingsClickOnEnterPromoCodeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsClickOnEnterPromoCode = function (params) {
        return this.bi.log(__assign({ evid: 571 }, params));
    };
    /**
    * @typedef {Object} bookingsReturnFromLoginParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} firstLogin - null
    * @property {boolean} is_over_editor - null
    * @property {boolean} is_owner - null
    * @property {boolean} isPreview - null
    * @property {GUID} biToken - null
    * @property {string} pageName - null
    * @property {boolean} success - null
    * @property {GUID} visitor_id - null
    * @property {GUID} visitorIdAnon - the visitor_id when the visitor is anonymous- not logged in
    **/
    /**
     * Name: bookings >return from login. Evid: 543.
     * Event description: return from login.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * firstLogin - Type: bool.
     *
     * is_over_editor - Type: bool.
     *
     * is_owner - Type: bool.
     *
     * isPreview - Type: bool.
     *
     * biToken - Type: guid.
     *
     * pageName - Type: string.
     *
     * success - Type: bool.
     *
     * visitor_id - Type: guid.
     *
     * visitorIdAnon - Type: guid. Desc: the visitor_id when the visitor is anonymous- not logged in
     * @param {bookingsReturnFromLoginParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsReturnFromLogin = function (params) {
        return this.bi.log(__assign({ evid: 543 }, params));
    };
    /**
    * @typedef {Object} bookingsChangeParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - -
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - null
    * @property {GUID} biToken - null
    * @property {string} section - {booking_summary,contact_info}
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings > change. Evid: 508.
     * Event description: Cancelled.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: -
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool.
     *
     * biToken - Type: guid.
     *
     * section - Type: string. Desc: {booking_summary,contact_info}
     *
     * visitor_id - Type: guid.
     * @param {bookingsChangeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsChange = function (params) {
        return this.bi.log(__assign({ evid: 508 }, params));
    };
    /**
    * @typedef {Object} bookingsOpenDatesCalendarParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - -
    * @property {boolean} is_owner - is_owner
    * @property {GUID} biToken - null
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Bookings --> OneApp --> click on the 3 dots (edit a session). Evid: 503.
     * Event description: Click on the 3 dots from an appointment or a class instance in order to change it.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: -
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * biToken - Type: guid.
     *
     * visitor_id - Type: guid.
     * @param {bookingsOpenDatesCalendarParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsOpenDatesCalendar = function (params) {
        return this.bi.log(__assign({ evid: 503 }, params));
    };
    /**
    * @typedef {Object} bookingsServicePageSeeAllServicesClickParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - editor or viewer
    * @property {boolean} is_owner - is_owner
    * @property {GUID} biToken - null
    * @property {string} selection - {course_schedule}
    * @property {string} serviceId - service_id
    * @property {string} type - course.class
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings >service_page>see all sessions. Evid: 556.
     * Event description: course - see all schedules.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: editor or viewer
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * biToken - Type: guid.
     *
     * selection - Type: string. Desc: {course_schedule}
     *
     * serviceId - Type: string. Desc: service_id
     *
     * type - Type: string. Desc: course.class
     *
     * visitor_id - Type: guid.
     * @param {bookingsServicePageSeeAllServicesClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsServicePageSeeAllServicesClick = function (params) {
        return this.bi.log(__assign({ evid: 556 }, params));
    };
    /**
    * @typedef {Object} bookingsLoginUserAccountPersonalInfoSaveClickParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - null
    * @property {GUID} biToken - null
    * @property {boolean} nameChanged - T= name changed
    * @property {boolean} phoneChanged - T= phone changed
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings >login. user account > personal info> save.click. Evid: 550.
     * Event description: on the user account (myaccount) page > personal info tab - click on save http://prntscr.com/dqa5g6.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool.
     *
     * biToken - Type: guid.
     *
     * nameChanged - Type: bool. Desc: T= name changed
     *
     * phoneChanged - Type: bool. Desc: T= phone changed
     *
     * visitor_id - Type: guid.
     * @param {bookingsLoginUserAccountPersonalInfoSaveClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsLoginUserAccountPersonalInfoSaveClick = function (params) {
        return this.bi.log(__assign({ evid: 550 }, params));
    };
    /**
    * @typedef {Object} bookingsCalendarChooseStaffMemberParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - editor or viewer
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - null
    * @property {GUID} biToken - null
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings >calendar>choose_staff_member. Evid: 530.
     * Event description: sent when the UoU choose a staff member to provide the service in the tooltip (only when all staff is selected in dropdown filter).
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: editor or viewer
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool.
     *
     * biToken - Type: guid.
     *
     * visitor_id - Type: guid.
     * @param {bookingsCalendarChooseStaffMemberParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsCalendarChooseStaffMember = function (params) {
        return this.bi.log(__assign({ evid: 530 }, params));
    };
    /**
    * @typedef {Object} bookingsChooseADateOnCalendarParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - business_id
    * @property {GUID} contactId - contact_id
    * @property {boolean} is_over_editor - -
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - null
    * @property {GUID} biToken - msid
    * @property {string} platform - {mobile,pc}
    * @property {boolean} reschedule - T=is reschedule F= regular
    * @property {GUID} site_member_id - site_member_id
    * @property {string} type - {class\ind}
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: bookings > choose a date on calendar. Evid: 570.
     * Event description: choose a date on the calendar.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid. Desc: business_id
     *
     * contactId - Type: guid. Desc: contact_id
     *
     * is_over_editor - Type: bool. Desc: -
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool.
     *
     * biToken - Type: guid. Desc: msid
     *
     * platform - Type: string. Desc: {mobile,pc}
     *
     * reschedule - Type: bool. Desc: T=is reschedule F= regular
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * type - Type: string. Desc: {class\ind}
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {bookingsChooseADateOnCalendarParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsChooseADateOnCalendar = function (params) {
        return this.bi.log(__assign({ evid: 570 }, params));
    };
    /**
    * @typedef {Object} bookingsPickDatesMobileParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - is_over_editor
    * @property {boolean} is_owner - is_owner
    * @property {GUID} biToken - null
    * @property {string} pid - page_id
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings > pick dates mobile. Evid: 516.
     * Event description: NEED TO DELETE - 506 instead.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: is_over_editor
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * biToken - Type: guid.
     *
     * pid - Type: string. Desc: page_id
     *
     * visitor_id - Type: guid.
     * @param {bookingsPickDatesMobileParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsPickDatesMobile = function (params) {
        return this.bi.log(__assign({ evid: 516 }, params));
    };
    /**
    * @typedef {Object} bookingsLoginUserAccountSeeAllServicesClickParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - null
    * @property {GUID} biToken - null
    * @property {string} referralInfo - on what tab the button was clicked -{appointments, personal info}
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings >login. user account > see all services.click. Evid: 549.
     * Event description: click on the" see all services" button on the user account page - http://prntscr.com/dqa0rl.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool.
     *
     * biToken - Type: guid.
     *
     * referralInfo - Type: string. Desc: on what tab the button was clicked -{appointments, personal info}
     *
     * visitor_id - Type: guid.
     * @param {bookingsLoginUserAccountSeeAllServicesClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsLoginUserAccountSeeAllServicesClick = function (params) {
        return this.bi.log(__assign({ evid: 549 }, params));
    };
    /**
    * @typedef {Object} bookingsServicesListViewParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - -
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - null
    * @property {GUID} biToken - null
    * @property {string} pid - null = web. for oneapp = {schedule_tab, services_tab}
    * @property {string} type - group\private\both
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings > services List. view. Evid: 515.
     * Event description: app page is viewed on site- services page opened.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: -
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool.
     *
     * biToken - Type: guid.
     *
     * pid - Type: string. Desc: null = web. for oneapp = {schedule_tab, services_tab}
     *
     * type - Type: string. Desc: group\private\both
     *
     * visitor_id - Type: guid.
     * @param {bookingsServicesListViewParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsServicesListView = function (params) {
        return this.bi.log(__assign({ evid: 515 }, params));
    };
    /**
    * @typedef {Object} bookingsCancellationPolicyParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - -
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - null
    * @property {GUID} biToken - null
    * @property {string} type - {class\ind}
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings > cancellation policy. Evid: 521.
     * Event description: cancellation policy- Visitor.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: -
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool.
     *
     * biToken - Type: guid.
     *
     * type - Type: string. Desc: {class\ind}
     *
     * visitor_id - Type: guid.
     * @param {bookingsCancellationPolicyParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsCancellationPolicy = function (params) {
        return this.bi.log(__assign({ evid: 521 }, params));
    };
    /**
    * @typedef {Object} bookingsConfirmAnotherParticipantRemovalPhase2Params
    * @property {boolean} approve - T=approved, F= canceled
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - editor or viewer
    * @property {boolean} is_owner - is_owner
    * @property {GUID} biToken - null
    * @property {string} serviceId - -
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings > confirm another participant removal - phase 2. Evid: 537.
     * Event description: approve\not approve another participant removal
    http://prntscr.com/bjzjty.
    
     * approve - Type: bool. Desc: T=approved, F= canceled
     *
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: editor or viewer
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * biToken - Type: guid.
     *
     * serviceId - Type: string. Desc: -
     *
     * visitor_id - Type: guid.
     * @param {bookingsConfirmAnotherParticipantRemovalPhase2Params} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsConfirmAnotherParticipantRemovalPhase2 = function (params) {
        return this.bi.log(__assign({ evid: 537 }, params));
    };
    /**
    * @typedef {Object} bookingsAppointmentBookedParams
    * @property {number} amountPaid - Price paid by user, multiplied by num_participants, after discounts. For offline = 0. Multiplied by 10,000
    * @property {string} bookingId - null
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - booking_id = order_id in evid 16:1010
    * @property {string} catId - null
    * @property {GUID} contactId - null
    * @property {GUID} couponId - coupon_id
    * @property {string} currency - service booked currency
    * @property {number} depositAmount - Multiplied by 10,000
    * @property {boolean} is_coupon - 0- if coupon not used. 1 if coupon is applied.
    * @property {boolean} is_membership - 1 or 0
    * @property {boolean} is_over_editor - editor or viewer
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPendingApproval - is pending approval service
    * @property {boolean} isPreview - null
    * @property {boolean} logged - T= logged in, F= not
    * @property {GUID} biToken - null
    * @property {number} numParticipants - default=1
    * @property {number} originalPrice - Not relevant!
    * @property {string} paymentMethod - {offline,online, paid_plan_limited, paid_plan_unlimited}
    * @property {string} platform - {mobile,pc}
    * @property {number} price - Original Service Price, before discounts (NOT multiplied by num_participants). Multiplied by 10,000
    * @property {string} price_selection - -
    * @property {string} referal_info - for one-click book (oneapp) = "agenda", else null
    * @property {string} serviceId - -
    * @property {number} totalPrice - Price multiplied by num_participants, after discounts. Multiplied by 10,000
    * @property {string} type - {class\ind\course}
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings > appointment booked. Evid: 526.
     * Event description: Appointment is booked (offline or online payment ).
    
     * amountPaid - Type: numeric. Desc: Price paid by user, multiplied by num_participants, after discounts. For offline = 0. Multiplied by 10,000
     *
     * bookingId - Type: string.
     *
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid. Desc: booking_id = order_id in evid 16:1010
     *
     * catId - Type: string.
     *
     * contactId - Type: guid.
     *
     * couponId - Type: guid. Desc: coupon_id
     *
     * currency - Type: string. Desc: service booked currency
     *
     * depositAmount - Type: numeric. Desc: Multiplied by 10,000
     *
     * is_coupon - Type: bool. Desc: 0- if coupon not used. 1 if coupon is applied.
     *
     * is_membership - Type: bool. Desc: 1 or 0
     *
     * is_over_editor - Type: bool. Desc: editor or viewer
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPendingApproval - Type: bool. Desc: is pending approval service
     *
     * isPreview - Type: bool.
     *
     * logged - Type: bool. Desc: T= logged in, F= not
     *
     * biToken - Type: guid.
     *
     * numParticipants - Type: numeric. Desc: default=1
     *
     * originalPrice - Type: numeric. Desc: Not relevant!
     *
     * paymentMethod - Type: string. Desc: {offline,online, paid_plan_limited, paid_plan_unlimited}
     *
     * platform - Type: string. Desc: {mobile,pc}
     *
     * price - Type: numeric. Desc: Original Service Price, before discounts (NOT multiplied by num_participants). Multiplied by 10,000
     *
     * price_selection - Type: string. Desc: -
     *
     * referal_info - Type: string. Desc: for one-click book (oneapp) = "agenda", else null
     *
     * serviceId - Type: string. Desc: -
     *
     * totalPrice - Type: numeric. Desc: Price multiplied by num_participants, after discounts. Multiplied by 10,000
     *
     * type - Type: string. Desc: {class\ind\course}
     *
     * visitor_id - Type: guid.
     * @param {bookingsAppointmentBookedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsAppointmentBooked = function (params) {
        return this.bi.log(__assign({ evid: 526 }, params));
    };
    /**
    * @typedef {Object} bookingsDownloadClickForUouParams
    * @property {string} additionalInfo - CTA description {waitlist_flow_download_oa}
    * @property {string} bookingsPlatform - -
    * @property {GUID} businessId - -
    * @property {GUID} contactId - -
    * @property {boolean} is_over_editor - is_over_editor
    * @property {boolean} isPreview - 1 if this is preview mode, 0 if live site
    * @property {GUID} biToken - -
    * @property {string} premiumStatus - {free,non_bookings_premium}
    * @property {string} referral_info - {Payments/Booking/Waitlist}
    * @property {string} type - Service type {appointment, class, course}
    * @property {GUID} visitor_id - -
    **/
    /**
     * Name: Bookings > download click for UoU. Evid: 582.
     * Event description: For any download CTA clicked by UoU or owner only on preview mode or live..
    
     * additionalInfo - Type: string. Desc: CTA description {waitlist_flow_download_oa}
     *
     * bookingsPlatform - Type: string. Desc: -
     *
     * businessId - Type: guid. Desc: -
     *
     * contactId - Type: guid. Desc: -
     *
     * is_over_editor - Type: bool. Desc: is_over_editor
     *
     * isPreview - Type: bool. Desc: 1 if this is preview mode, 0 if live site
     *
     * biToken - Type: guid. Desc: -
     *
     * premiumStatus - Type: string. Desc: {free,non_bookings_premium}
     *
     * referral_info - Type: string. Desc: {Payments/Booking/Waitlist}
     *
     * type - Type: string. Desc: Service type {appointment, class, course}
     *
     * visitor_id - Type: guid. Desc: -
     * @param {bookingsDownloadClickForUouParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsDownloadClickForUou = function (params) {
        return this.bi.log(__assign({ evid: 582 }, params));
    };
    /**
    * @typedef {Object} bookingsMoveDatesCalendarParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {string} direction - {backward,farward}
    * @property {boolean} is_over_editor - -
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - null
    * @property {GUID} biToken - null
    * @property {string} platform - {mobile,pc}
    * @property {string} type - {week,month}
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Bookings > Reschedule a session > uou flow. Evid: 504.
     * Event description: move Dates calendar - also available from OneApp (with roles = owner, since uou don't have this reschedule flow on the app).
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * direction - Type: string. Desc: {backward,farward}
     *
     * is_over_editor - Type: bool. Desc: -
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool.
     *
     * biToken - Type: guid.
     *
     * platform - Type: string. Desc: {mobile,pc}
     *
     * type - Type: string. Desc: {week,month}
     *
     * visitor_id - Type: guid.
     * @param {bookingsMoveDatesCalendarParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsMoveDatesCalendar = function (params) {
        return this.bi.log(__assign({ evid: 504 }, params));
    };
    /**
    * @typedef {Object} bookingsClickLoadMoreHoursParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - business_id
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - is_over_editor
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - is_preview
    * @property {GUID} biToken - null
    * @property {string} platform - {mobile,pc}
    * @property {boolean} reschedule - T=is reschedule F= regular
    * @property {string} type - {class\ind}
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Bookings > click "load more hours". Evid: 578.
     * Event description: click in the "load more hours" option in the calendar (currently only available from mobile).
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid. Desc: business_id
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: is_over_editor
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool. Desc: is_preview
     *
     * biToken - Type: guid.
     *
     * platform - Type: string. Desc: {mobile,pc}
     *
     * reschedule - Type: bool. Desc: T=is reschedule F= regular
     *
     * type - Type: string. Desc: {class\ind}
     *
     * visitor_id - Type: guid.
     * @param {bookingsClickLoadMoreHoursParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsClickLoadMoreHours = function (params) {
        return this.bi.log(__assign({ evid: 578 }, params));
    };
    /**
    * @typedef {Object} bookingsReturnFromExternalPaymentProviderAfterOnlinePaymentParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {string} currency - NOT SENT
    * @property {number} depositAmount - NOT SENT
    * @property {boolean} is_over_editor - -
    * @property {boolean} is_owner - is_owner
    * @property {GUID} biToken - null
    * @property {string} paymentProvider - {paypal, stripe}
    * @property {string} platform - {mobile,pc}
    * @property {number} price - multiplied by 10,000
    * @property {string} serviceId - -
    * @property {boolean} success - -
    * @property {string} type - {class\ind}
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings > return from external payment provider after online payment. Evid: 519.
     * Event description: return after paypal connect.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * currency - Type: string. Desc: NOT SENT
     *
     * depositAmount - Type: numeric. Desc: NOT SENT
     *
     * is_over_editor - Type: bool. Desc: -
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * biToken - Type: guid.
     *
     * paymentProvider - Type: string. Desc: {paypal, stripe}
     *
     * platform - Type: string. Desc: {mobile,pc}
     *
     * price - Type: numeric. Desc: multiplied by 10,000
     *
     * serviceId - Type: string. Desc: -
     *
     * success - Type: bool. Desc: -
     *
     * type - Type: string. Desc: {class\ind}
     *
     * visitor_id - Type: guid.
     * @param {bookingsReturnFromExternalPaymentProviderAfterOnlinePaymentParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsReturnFromExternalPaymentProviderAfterOnlinePayment = function (params) {
        return this.bi.log(__assign({ evid: 519 }, params));
    };
    /**
    * @typedef {Object} bookingsSendPageIdParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - -
    * @property {boolean} is_owner - is_owner
    * @property {GUID} biToken - null
    * @property {string} pid - page_id
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings > send page id. Evid: 514.
     * Event description: send page id. Since 30 of May we're not sending this.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: -
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * biToken - Type: guid.
     *
     * pid - Type: string. Desc: page_id
     *
     * visitor_id - Type: guid.
     * @param {bookingsSendPageIdParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsSendPageId = function (params) {
        return this.bi.log(__assign({ evid: 514 }, params));
    };
    /**
    * @typedef {Object} bookingsLoginUserAccountAppointmentsRescheduleSuccessParams
    * @property {GUID} appointmentId - appointment rescheduled
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - null
    * @property {GUID} biToken - null
    * @property {string} serviceid - service rescheduled
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings >login. user account > appointments> reschedule. success. Evid: 551.
     * Event description: on the user account (myaccount) page > appointments tab - after click on reschedule (appointment http://prntscr.com/dq9z2z) the visitor choose another date & time and clicks on next --> reschedule success.
    
     * appointmentId - Type: guid. Desc: appointment rescheduled
     *
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool.
     *
     * biToken - Type: guid.
     *
     * serviceid - Type: string. Desc: service rescheduled
     *
     * visitor_id - Type: guid.
     * @param {bookingsLoginUserAccountAppointmentsRescheduleSuccessParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsLoginUserAccountAppointmentsRescheduleSuccess = function (params) {
        return this.bi.log(__assign({ evid: 551 }, params));
    };
    /**
    * @typedef {Object} bookingsLoginUserAccountAppointmentsCancelClickParams
    * @property {GUID} appointmentId - appointment rescheduled
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {boolean} confirmation - T= confirmation for delete F= first click
    * @property {GUID} contactId - null
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPendingApproval - T/F for pending approval service
    * @property {boolean} isPreview - null
    * @property {GUID} biToken - null
    * @property {string} referralInfo - {upcoming, one_app_main_tab, one_app_upcoming_my_bookings, waiting_list}
    * @property {string} serviceid - service rescheduled
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings >login. user account > appointments> cancel.click. Evid: 547.
     * Event description: on the user account (myaccount) page > appointments tab - click on cancel appointment. for the first click (http://prntscr.com/dq9zox) send confirmation=F, for the second (http://prntscr.com/dqa01c) send confirmation=T.
    
     * appointmentId - Type: guid. Desc: appointment rescheduled
     *
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * confirmation - Type: bool. Desc: T= confirmation for delete F= first click
     *
     * contactId - Type: guid.
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPendingApproval - Type: bool. Desc: T/F for pending approval service
     *
     * isPreview - Type: bool.
     *
     * biToken - Type: guid.
     *
     * referralInfo - Type: string. Desc: {upcoming, one_app_main_tab, one_app_upcoming_my_bookings, waiting_list}
     *
     * serviceid - Type: string. Desc: service rescheduled
     *
     * visitor_id - Type: guid.
     * @param {bookingsLoginUserAccountAppointmentsCancelClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsLoginUserAccountAppointmentsCancelClick = function (params) {
        return this.bi.log(__assign({ evid: 547 }, params));
    };
    /**
    * @typedef {Object} bookingsCalendarPageLoadedParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - editor or viewer
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - null
    * @property {GUID} biToken - null
    * @property {string} referralInfo - {NULL= app settings, widget}
    * @property {string} service_id - -
    * @property {string} type - {class\ind}
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings > calendar page loaded. Evid: 541.
     * Event description: calendar page loaded - sent only from the widget as a referal.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: editor or viewer
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool.
     *
     * biToken - Type: guid.
     *
     * referralInfo - Type: string. Desc: {NULL= app settings, widget}
     *
     * service_id - Type: string. Desc: -
     *
     * type - Type: string. Desc: {class\ind}
     *
     * visitor_id - Type: guid.
     * @param {bookingsCalendarPageLoadedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsCalendarPageLoaded = function (params) {
        return this.bi.log(__assign({ evid: 541 }, params));
    };
    /**
    * @typedef {Object} bookingsUpgradeReferralClickUserAsUouParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - -
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - -
    * @property {boolean} is_owner - -
    * @property {boolean} isPreview - 1 if this is preview mode, 0 if live site
    * @property {GUID} biToken - -
    * @property {string} premiumStatus - {free,non_bookings_premium}
    * @property {string} referral_info - {Payments, Booking}
    * @property {string} type - Service type {appointment, class, course}
    * @property {GUID} visitor_id - -
    **/
    /**
     * Name: Bookings > upgrade referral.click (user as UoU). Evid: 559.
     * Event description: http://prntscr.com/g0jwsx.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid. Desc: -
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: -
     *
     * is_owner - Type: bool. Desc: -
     *
     * isPreview - Type: bool. Desc: 1 if this is preview mode, 0 if live site
     *
     * biToken - Type: guid. Desc: -
     *
     * premiumStatus - Type: string. Desc: {free,non_bookings_premium}
     *
     * referral_info - Type: string. Desc: {Payments, Booking}
     *
     * type - Type: string. Desc: Service type {appointment, class, course}
     *
     * visitor_id - Type: guid. Desc: -
     * @param {bookingsUpgradeReferralClickUserAsUouParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsUpgradeReferralClickUserAsUou = function (params) {
        return this.bi.log(__assign({ evid: 559 }, params));
    };
    /**
    * @typedef {Object} bookingsTimeTableWidgetLoadParams
    * @property {string} additionalInfo - date presented
    * @property {string} bookingsPlatform - -
    * @property {GUID} businessId - -
    * @property {GUID} contactId - -
    * @property {boolean} isEmptyState - true = empty state
    * @property {boolean} is_over_editor - editor or viewer
    * @property {boolean} is_owner - is_owner
    * @property {GUID} biToken - -
    * @property {GUID} visitor_id - -
    * @property {string} widget_name - {daily_time_table, weekly_time_table}
    **/
    /**
     * Name: bookings > time table widget load. Evid: 580.
     * Event description: calendar page loaded - sent only from the widget as a referal.
    
     * additionalInfo - Type: string. Desc: date presented
     *
     * bookingsPlatform - Type: string. Desc: -
     *
     * businessId - Type: guid. Desc: -
     *
     * contactId - Type: guid. Desc: -
     *
     * isEmptyState - Type: bool. Desc: true = empty state
     *
     * is_over_editor - Type: bool. Desc: editor or viewer
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * biToken - Type: guid. Desc: -
     *
     * visitor_id - Type: guid. Desc: -
     *
     * widget_name - Type: string. Desc: {daily_time_table, weekly_time_table}
     * @param {bookingsTimeTableWidgetLoadParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsTimeTableWidgetLoad = function (params) {
        return this.bi.log(__assign({ evid: 580 }, params));
    };
    /**
    * @typedef {Object} bookingsTimeZoneDiscrepancyParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - -
    * @property {string} contact_id - optional
    * @property {GUID} contactId - null
    * @property {string} local_date_time - -
    * @property {GUID} biToken - null
    * @property {string} source - Server/BO
    * @property {string} timezone - timezone on which there was a discrepancy
    * @property {number} timestamp - epoch time
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Bookings > TimeZone Discrepancy. Evid: 1014.
     * Event description: This event is reported when there is a discrepancy between the business timezone and the user/uou timezone when calendar loads or when uou tries to book.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid. Desc: -
     *
     * contact_id - Type: string. Desc: optional
     *
     * contactId - Type: guid.
     *
     * local_date_time - Type: string. Desc: -
     *
     * biToken - Type: guid.
     *
     * source - Type: string. Desc: Server/BO
     *
     * timezone - Type: string. Desc: timezone on which there was a discrepancy
     *
     * timestamp - Type: numeric. Desc: epoch time
     *
     * visitor_id - Type: guid.
     * @param {bookingsTimeZoneDiscrepancyParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsTimeZoneDiscrepancy = function (params) {
        return this.bi.log(__assign({ evid: 1014 }, params));
    };
    /**
    * @typedef {Object} bookingsPaymentsPopupForUserAsUouOpenedParams
    * @property {string} additionalInfo - description of the modal/popup flow {waitlist_flow_download_oa}
    * @property {string} bookingId - booking_id
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - -
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - is_over_editor
    * @property {boolean} isPreview - 1 if this is preview mode, 0 if live site
    * @property {GUID} biToken - -
    * @property {string} premiumStatus - {free,non_bookings_premium}
    * @property {string} referral_info - {Payments/Booking/Waitlist/Booking_Cancellation/Double_Booking_Reschedule/Double_Booking_Payment_Page/Double_Booking_Form_Page/Double_Booking_Payment_Page_Book}
    * @property {string} type - Service type {appointment, class, course}
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Bookings > popup opened for UoU. Evid: 558.
     * Event description: Till November-2019: Bookings > popup for user as UoU opened.
    Similar to evid 157 on users schema  - popup opens for owner only on preview mode or live. From November-2019: Bookings > popup opened for UoU. For any popup opens to UoU..
    
     * additionalInfo - Type: string. Desc: description of the modal/popup flow {waitlist_flow_download_oa}
     *
     * bookingId - Type: string. Desc: booking_id
     *
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid. Desc: -
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: is_over_editor
     *
     * isPreview - Type: bool. Desc: 1 if this is preview mode, 0 if live site
     *
     * biToken - Type: guid. Desc: -
     *
     * premiumStatus - Type: string. Desc: {free,non_bookings_premium}
     *
     * referral_info - Type: string. Desc: {Payments/Booking/Waitlist/Booking_Cancellation/Double_Booking_Reschedule/Double_Booking_Payment_Page/Double_Booking_Form_Page/Double_Booking_Payment_Page_Book}
     *
     * type - Type: string. Desc: Service type {appointment, class, course}
     *
     * visitor_id - Type: guid.
     * @param {bookingsPaymentsPopupForUserAsUouOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsPaymentsPopupForUserAsUouOpened = function (params) {
        return this.bi.log(__assign({ evid: 558 }, params));
    };
    /**
    * @typedef {Object} bookingsCalendarChooseStaffMemberPopupOpenedParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - editor or viewer
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - null
    * @property {GUID} biToken - null
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings >calendar>choose_staff_member_popup_opened. Evid: 531.
     * Event description: sent when the tooltip of choose member is opened in the calendar (only services that have more than one member defined).
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: editor or viewer
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool.
     *
     * biToken - Type: guid.
     *
     * visitor_id - Type: guid.
     * @param {bookingsCalendarChooseStaffMemberPopupOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsCalendarChooseStaffMemberPopupOpened = function (params) {
        return this.bi.log(__assign({ evid: 531 }, params));
    };
    /**
    * @typedef {Object} bookingsPaymentsSentToPaymentProviderParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - -
    * @property {boolean} is_owner - is_owner
    * @property {GUID} biToken - null
    * @property {string} paymentProvider - NULL=paypal, stripe
    * @property {string} type - {class\ind}
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings > payments>sent to payment_provider. Evid: 528.
     * Event description: paypal window is opened when clicked on 'pay now' - payment of the service was defined online.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: -
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * biToken - Type: guid.
     *
     * paymentProvider - Type: string. Desc: NULL=paypal, stripe
     *
     * type - Type: string. Desc: {class\ind}
     *
     * visitor_id - Type: guid.
     * @param {bookingsPaymentsSentToPaymentProviderParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsPaymentsSentToPaymentProvider = function (params) {
        return this.bi.log(__assign({ evid: 528 }, params));
    };
    /**
    * @typedef {Object} bookingsContactInfoSaveSuccessParams
    * @property {string} bookingId - booking_id = order_id in evid 16:1010
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {string} catId - null
    * @property {GUID} contactId - null
    * @property {string} currency - null
    * @property {number} depositAmount - null
    * @property {boolean} is_over_editor - null
    * @property {boolean} is_owner - null
    * @property {boolean} isPreview - null
    * @property {boolean} message_empty - null
    * @property {GUID} biToken - null
    * @property {number} numParticipants - null
    * @property {number} numberOfRequiredFields - numbers of fields the UoU needs to fill
    * @property {string} platform - null
    * @property {number} price - null
    * @property {string} price_selection - null
    * @property {string} serviceId - null
    * @property {boolean} smsNotificationRequest - T/F
    * @property {GUID} staffId - staff_id
    * @property {string} timeslot - session start time
    * @property {string} type - null
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings > contact info save success. Evid: 517.
     * Event description: contact info save success.
    
     * bookingId - Type: string. Desc: booking_id = order_id in evid 16:1010
     *
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * catId - Type: string.
     *
     * contactId - Type: guid.
     *
     * currency - Type: string.
     *
     * depositAmount - Type: numeric.
     *
     * is_over_editor - Type: bool.
     *
     * is_owner - Type: bool.
     *
     * isPreview - Type: bool.
     *
     * message_empty - Type: bool.
     *
     * biToken - Type: guid.
     *
     * numParticipants - Type: numeric.
     *
     * numberOfRequiredFields - Type: numeric. Desc: numbers of fields the UoU needs to fill
     *
     * platform - Type: string.
     *
     * price - Type: numeric.
     *
     * price_selection - Type: string.
     *
     * serviceId - Type: string.
     *
     * smsNotificationRequest - Type: bool. Desc: T/F
     *
     * staffId - Type: guid. Desc: staff_id
     *
     * timeslot - Type: string. Desc: session start time
     *
     * type - Type: string.
     *
     * visitor_id - Type: guid.
     * @param {bookingsContactInfoSaveSuccessParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsContactInfoSaveSuccess = function (params) {
        return this.bi.log(__assign({ evid: 517 }, params));
    };
    /**
    * @typedef {Object} bookingsWidgetPageLoadedParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - -
    * @property {boolean} is_owner - is_owner
    * @property {GUID} biToken - null
    * @property {number} numOfServices - 0 if no services in the widget
    * @property {string} origin - {staff_widget}
    * @property {string} serviceId - -
    * @property {GUID} visitor_id - null
    * @property {string} widget_name - widget version
    **/
    /**
     * Name: bookings > widget page loaded. Evid: 540.
     * Event description: widget page loaded - sent once for each widget.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: -
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * biToken - Type: guid.
     *
     * numOfServices - Type: numeric. Desc: 0 if no services in the widget
     *
     * origin - Type: string. Desc: {staff_widget}
     *
     * serviceId - Type: string. Desc: -
     *
     * visitor_id - Type: guid.
     *
     * widget_name - Type: string. Desc: widget version
     * @param {bookingsWidgetPageLoadedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsWidgetPageLoaded = function (params) {
        return this.bi.log(__assign({ evid: 540 }, params));
    };
    /**
    * @typedef {Object} bookingsServicesPageViewParams
    * @property {boolean} accept_online_bookings - FALSE only if this a "no book flow"
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - -
    * @property {GUID} contactId - null
    * @property {string} containers - null
    * @property {boolean} emptyState - T if empty state, F if not
    * @property {boolean} is_over_editor - -
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - null
    * @property {string} message_to_user - {fully booked, not yet opened to bookings, not accepting bookings, service not available}
    * @property {GUID} biToken - msid
    * @property {string} platform - platform of user. example: "mobile".
    * @property {string} referralInfo - visitor origin to the SP. {'service title', 'learn more', 'service card deep link'}
    * @property {string} sections - null
    * @property {string} serviceId - null
    * @property {string} type - group\private\course
    * @property {GUID} visitor_id - -
    **/
    /**
     * Name: bookings > services page view. Evid: 560.
     * Event description: services page opened.
    
     * accept_online_bookings - Type: bool. Desc: FALSE only if this a "no book flow"
     *
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid. Desc: -
     *
     * contactId - Type: guid.
     *
     * containers - Type: string.
     *
     * emptyState - Type: bool. Desc: T if empty state, F if not
     *
     * is_over_editor - Type: bool. Desc: -
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool.
     *
     * message_to_user - Type: string. Desc: {fully booked, not yet opened to bookings, not accepting bookings, service not available}
     *
     * biToken - Type: guid. Desc: msid
     *
     * platform - Type: string. Desc: platform of user. example: "mobile".
     *
     * referralInfo - Type: string. Desc: visitor origin to the SP. {'service title', 'learn more', 'service card deep link'}
     *
     * sections - Type: string.
     *
     * serviceId - Type: string.
     *
     * type - Type: string. Desc: group\private\course
     *
     * visitor_id - Type: guid. Desc: -
     * @param {bookingsServicesPageViewParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsServicesPageView = function (params) {
        return this.bi.log(__assign({ evid: 560 }, params));
    };
    /**
    * @typedef {Object} bookingsLoginUserAccountTabNavigatorParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} isEmptyState - is appointments list empty
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - null
    * @property {GUID} biToken - null
    * @property {string} selection - {appointments, personal info}
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings >login. user account > tab navigator. Evid: 548.
     * Event description: click on the tab navigator on the user account page - http://prntscr.com/dqa0c9.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * isEmptyState - Type: bool. Desc: is appointments list empty
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool.
     *
     * biToken - Type: guid.
     *
     * selection - Type: string. Desc: {appointments, personal info}
     *
     * visitor_id - Type: guid.
     * @param {bookingsLoginUserAccountTabNavigatorParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsLoginUserAccountTabNavigator = function (params) {
        return this.bi.log(__assign({ evid: 548 }, params));
    };
    /**
    * @typedef {Object} bookingsLoginFinishedRefreshAfterLoginParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - -
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - -
    * @property {boolean} is_owner - -
    * @property {boolean} isPreview - T/F
    * @property {GUID} biToken - msid
    * @property {GUID} visitor_id - logged in visitor
    * @property {GUID} visitorIdAnon - the visitor_id when the visitor is anonymous- not logged in
    **/
    /**
     * Name: bookings >login.finished refresh after login. Evid: 557.
     * Event description: bookings >finished refresh after login.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid. Desc: -
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: -
     *
     * is_owner - Type: bool. Desc: -
     *
     * isPreview - Type: bool. Desc: T/F
     *
     * biToken - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid. Desc: logged in visitor
     *
     * visitorIdAnon - Type: guid. Desc: the visitor_id when the visitor is anonymous- not logged in
     * @param {bookingsLoginFinishedRefreshAfterLoginParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsLoginFinishedRefreshAfterLogin = function (params) {
        return this.bi.log(__assign({ evid: 557 }, params));
    };
    /**
    * @typedef {Object} bookingsLoginClickParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - editor or viewer
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - null
    * @property {GUID} biToken - null
    * @property {string} pageName - {service_list,calendar,personal_info...}
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings >login. click. Evid: 542.
     * Event description: click on login.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: editor or viewer
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool.
     *
     * biToken - Type: guid.
     *
     * pageName - Type: string. Desc: {service_list,calendar,personal_info...}
     *
     * visitor_id - Type: guid.
     * @param {bookingsLoginClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsLoginClick = function (params) {
        return this.bi.log(__assign({ evid: 542 }, params));
    };
    /**
    * @typedef {Object} bookingsPricingPlansViewParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - business_id
    * @property {GUID} contactId - contact_id
    * @property {boolean} is_over_editor - -
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - null
    * @property {GUID} biToken - msid
    * @property {number} number_of_plans - number of defined plans
    * @property {string} pid - page_id
    * @property {GUID} site_member_id - site_member_id - logged user
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: bookings > pricing plans - view. Evid: 567.
     * Event description: pricing plans page opened.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid. Desc: business_id
     *
     * contactId - Type: guid. Desc: contact_id
     *
     * is_over_editor - Type: bool. Desc: -
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool.
     *
     * biToken - Type: guid. Desc: msid
     *
     * number_of_plans - Type: numeric. Desc: number of defined plans
     *
     * pid - Type: string. Desc: page_id
     *
     * site_member_id - Type: guid. Desc: site_member_id - logged user
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {bookingsPricingPlansViewParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsPricingPlansView = function (params) {
        return this.bi.log(__assign({ evid: 567 }, params));
    };
    /**
    * @typedef {Object} bookingsOpenBookingsAppFromTheWidgetParams
    * @property {boolean} accept_online_bookings - FALSE only if this a "no book flow"
    * @property {string} booking_intent - {book it / more info = image and description}
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - -
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - -
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - is_preview
    * @property {GUID} biToken - msid
    * @property {string} referralInfo - {widget/wixCode}
    * @property {GUID} service_id - service_id
    * @property {string} type - group\private
    * @property {GUID} visitor_id - -
    **/
    /**
     * Name: Bookings --> open Bookings app from the widget. Evid: 577.
     * Event description: Bookings --> open Bookings app from the widget.
    
     * accept_online_bookings - Type: bool. Desc: FALSE only if this a "no book flow"
     *
     * booking_intent - Type: string. Desc: {book it / more info = image and description}
     *
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid. Desc: -
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: -
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool. Desc: is_preview
     *
     * biToken - Type: guid. Desc: msid
     *
     * referralInfo - Type: string. Desc: {widget/wixCode}
     *
     * service_id - Type: guid. Desc: service_id
     *
     * type - Type: string. Desc: group\private
     *
     * visitor_id - Type: guid. Desc: -
     * @param {bookingsOpenBookingsAppFromTheWidgetParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsOpenBookingsAppFromTheWidget = function (params) {
        return this.bi.log(__assign({ evid: 577 }, params));
    };
    /**
    * @typedef {Object} bookingsSystemMessageCloseParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - -
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - null
    * @property {GUID} biToken - null
    * @property {string} referal_info - {date&time, contact_info}
    * @property {string} type - {class\ind}
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings > system message close. Evid: 511.
     * Event description: Cancelled.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: -
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool.
     *
     * biToken - Type: guid.
     *
     * referal_info - Type: string. Desc: {date&time, contact_info}
     *
     * type - Type: string. Desc: {class\ind}
     *
     * visitor_id - Type: guid.
     * @param {bookingsSystemMessageCloseParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsSystemMessageClose = function (params) {
        return this.bi.log(__assign({ evid: 511 }, params));
    };
    /**
    * @typedef {Object} bookingsOneAppMeTabUpcomingTapParams
    * @property {string} bookingId - booking_id
    * @property {string} bookingsPlatform - new_bookings_server
    * @property {GUID} businessId - business_id
    * @property {GUID} contactId - -
    * @property {boolean} isPendingApproval - TRUE for pending approval services
    * @property {GUID} biToken - null
    * @property {string} serviceId - service_id
    * @property {string} type - service type {class\ind\course}
    * @property {GUID} visitor_id - null
    * @property {boolean} waitlistEnabled - TRUE if waitlist enabled
    **/
    /**
     * Name: Bookings --> OneApp --> Me Tab --> upcoming.tap. Evid: 584.
     * Event description: member taps on an booking  in me tab, upcoming section.
    
     * bookingId - Type: string. Desc: booking_id
     *
     * bookingsPlatform - Type: string. Desc: new_bookings_server
     *
     * businessId - Type: guid. Desc: business_id
     *
     * contactId - Type: guid. Desc: -
     *
     * isPendingApproval - Type: bool. Desc: TRUE for pending approval services
     *
     * biToken - Type: guid.
     *
     * serviceId - Type: string. Desc: service_id
     *
     * type - Type: string. Desc: service type {class\ind\course}
     *
     * visitor_id - Type: guid.
     *
     * waitlistEnabled - Type: bool. Desc: TRUE if waitlist enabled
     * @param {bookingsOneAppMeTabUpcomingTapParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsOneAppMeTabUpcomingTap = function (params) {
        return this.bi.log(__assign({ evid: 584 }, params));
    };
    /**
    * @typedef {Object} bookingsOneAppDeletePromoCodeParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - business_id
    * @property {GUID} contactId - null
    * @property {GUID} couponId - coupon_id
    * @property {GUID} biToken - msid
    * @property {string} type - service type {class\ind\course}
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Bookings --> OneApp --> delete promo code. Evid: 576.
     * Event description: Delete promo code after applying it - after clicking "save" with removing the code.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid. Desc: business_id
     *
     * contactId - Type: guid.
     *
     * couponId - Type: guid. Desc: coupon_id
     *
     * biToken - Type: guid. Desc: msid
     *
     * type - Type: string. Desc: service type {class\ind\course}
     *
     * visitor_id - Type: guid.
     * @param {bookingsOneAppDeletePromoCodeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsOneAppDeletePromoCode = function (params) {
        return this.bi.log(__assign({ evid: 576 }, params));
    };
    /**
    * @typedef {Object} bookingsAnotherParticipantActionsPhase2Params
    * @property {string} action - {remove, edit}
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - editor or viewer
    * @property {boolean} is_owner - is_owner
    * @property {GUID} biToken - null
    * @property {string} serviceId - -
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings > another participant actions - phase 2. Evid: 536.
     * Event description: click on edit\remove of another participants
    http://prntscr.com/bjzijo.
    
     * action - Type: string. Desc: {remove, edit}
     *
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: editor or viewer
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * biToken - Type: guid.
     *
     * serviceId - Type: string. Desc: -
     *
     * visitor_id - Type: guid.
     * @param {bookingsAnotherParticipantActionsPhase2Params} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsAnotherParticipantActionsPhase2 = function (params) {
        return this.bi.log(__assign({ evid: 536 }, params));
    };
    /**
    * @typedef {Object} bookingsOneAppClickOnEnterPromoCodeEditCodeParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - business_id
    * @property {GUID} contactId - null
    * @property {GUID} couponId - coupon_id - when edited
    * @property {GUID} biToken - msid
    * @property {string} type - {class\ind\course}
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Bookings --> OneApp --> click on "enter promo code"/Edit code. Evid: 574.
     * Event description: Click on enter promo code from Bookings summary page.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid. Desc: business_id
     *
     * contactId - Type: guid.
     *
     * couponId - Type: guid. Desc: coupon_id - when edited
     *
     * biToken - Type: guid. Desc: msid
     *
     * type - Type: string. Desc: {class\ind\course}
     *
     * visitor_id - Type: guid.
     * @param {bookingsOneAppClickOnEnterPromoCodeEditCodeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsOneAppClickOnEnterPromoCodeEditCode = function (params) {
        return this.bi.log(__assign({ evid: 574 }, params));
    };
    /**
    * @typedef {Object} bookingsTodayCalendarParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - -
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - null
    * @property {GUID} biToken - null
    * @property {string} type - {class\ind}
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings > today calendar. Evid: 505.
     * Event description: today calendar.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: -
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool.
     *
     * biToken - Type: guid.
     *
     * type - Type: string. Desc: {class\ind}
     *
     * visitor_id - Type: guid.
     * @param {bookingsTodayCalendarParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsTodayCalendar = function (params) {
        return this.bi.log(__assign({ evid: 505 }, params));
    };
    /**
    * @typedef {Object} bookingsMemberAreaListUploadParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - -
    * @property {GUID} contactId - -
    * @property {boolean} isEmptyState - is appointments list empty
    * @property {boolean} is_owner - is_owner
    * @property {GUID} biToken - -
    * @property {boolean} reschedule - {F = all reschedule disables or empty state; T = at least one reschedule}
    * @property {string} tabName - {upcoming, history}
    * @property {GUID} visitor_id - -
    **/
    /**
     * Name: Bookings > Members area (My Bookings) > list loaded. Evid: 562.
     * Event description: services list loaded (history/upcoming)
    http://prntscr.com/gsp5qm, OneApp: https://www.screencast.com/t/PKX1IdXTOm. Sends from mobile as well!!.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid. Desc: -
     *
     * contactId - Type: guid. Desc: -
     *
     * isEmptyState - Type: bool. Desc: is appointments list empty
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * biToken - Type: guid. Desc: -
     *
     * reschedule - Type: bool. Desc: {F = all reschedule disables or empty state; T = at least one reschedule}
     *
     * tabName - Type: string. Desc: {upcoming, history}
     *
     * visitor_id - Type: guid. Desc: -
     * @param {bookingsMemberAreaListUploadParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsMemberAreaListUpload = function (params) {
        return this.bi.log(__assign({ evid: 562 }, params));
    };
    /**
    * @typedef {Object} bookingsNextOrBookItParams
    * @property {boolean} accept_online_bookings - T/F
    * @property {string} booked_as - relevant only after the user choose a booking option (pricing plan limited/pricing plan unlimited/single)
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {string} catId - null
    * @property {GUID} contactId - null
    * @property {string} currency - null
    * @property {number} depositAmount - null
    * @property {boolean} email_empty - null
    * @property {boolean} errorOnStaff - only relevant for mobile flow on the calendar page - when having multiple staff members available and none selected
    * @property {boolean} is_coupon - only relevant for referral "contact_info": 0- if there is an option to use a coupon but not used. 1 if coupon is applied. null otherwise
    * @property {boolean} is_membership - 1 if there is an option to view pricing plans for this service (part of a membership or both)
    * @property {boolean} is_over_editor - null
    * @property {boolean} is_owner - null
    * @property {boolean} isPreview - null
    * @property {string} mandatoryFieldsList - mandatory fields list. for referal_info='Payment_Info' only.
    * @property {GUID} biToken - null
    * @property {boolean} name_empty - null
    * @property {number} numberOfRequiredFields - for referal_info='date&time' only. numbers of fields the UoU needs to fill
    * @property {string} offered_as - How is this service offered to uou (single, pricing plan, both)
    * @property {string} paymentMethod - null
    * @property {boolean} phone_empty - null
    * @property {string} platform - null
    * @property {number} price - null
    * @property {string} price_selection - null
    * @property {string} referal_info - date&time,contact_info,payment_info, one_app_group_session_select, one_app_appointment_session_select, one_app_date_time, one_app_agenda
    * @property {boolean} reschedule - null
    * @property {string} selected_plan - Only relevant when there are BOTH options {membership/single session}
    * @property {string} serviceId - null
    * @property {GUID} site_member_id - site_member_id - logged user
    * @property {boolean} smsNotificationRequest - TRUE if uou sms notification was requested. FALSE if not
    * @property {string} type - null
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings > next or book it. Evid: 509.
     * Event description: next or book it.
    
     * accept_online_bookings - Type: bool. Desc: T/F
     *
     * booked_as - Type: string. Desc: relevant only after the user choose a booking option (pricing plan limited/pricing plan unlimited/single)
     *
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * catId - Type: string.
     *
     * contactId - Type: guid.
     *
     * currency - Type: string.
     *
     * depositAmount - Type: numeric.
     *
     * email_empty - Type: bool.
     *
     * errorOnStaff - Type: bool. Desc: only relevant for mobile flow on the calendar page - when having multiple staff members available and none selected
     *
     * is_coupon - Type: bool. Desc: only relevant for referral "contact_info": 0- if there is an option to use a coupon but not used. 1 if coupon is applied. null otherwise
     *
     * is_membership - Type: bool. Desc: 1 if there is an option to view pricing plans for this service (part of a membership or both)
     *
     * is_over_editor - Type: bool.
     *
     * is_owner - Type: bool.
     *
     * isPreview - Type: bool.
     *
     * mandatoryFieldsList - Type: string. Desc: mandatory fields list. for referal_info='Payment_Info' only.
     *
     * biToken - Type: guid.
     *
     * name_empty - Type: bool.
     *
     * numberOfRequiredFields - Type: numeric. Desc: for referal_info='date&time' only. numbers of fields the UoU needs to fill
     *
     * offered_as - Type: string. Desc: How is this service offered to uou (single, pricing plan, both)
     *
     * paymentMethod - Type: string.
     *
     * phone_empty - Type: bool.
     *
     * platform - Type: string.
     *
     * price - Type: numeric.
     *
     * price_selection - Type: string.
     *
     * referal_info - Type: string. Desc: date&time,contact_info,payment_info, one_app_group_session_select, one_app_appointment_session_select, one_app_date_time, one_app_agenda
     *
     * reschedule - Type: bool.
     *
     * selected_plan - Type: string. Desc: Only relevant when there are BOTH options {membership/single session}
     *
     * serviceId - Type: string.
     *
     * site_member_id - Type: guid. Desc: site_member_id - logged user
     *
     * smsNotificationRequest - Type: bool. Desc: TRUE if uou sms notification was requested. FALSE if not
     *
     * type - Type: string.
     *
     * visitor_id - Type: guid.
     * @param {bookingsNextOrBookItParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsNextOrBookIt = function (params) {
        return this.bi.log(__assign({ evid: 509 }, params));
    };
    /**
    * @typedef {Object} bookingsServiceTypeWelcomePageClickedParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - editor or viewer
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - null
    * @property {GUID} biToken - null
    * @property {string} platform - {mobile,pc}
    * @property {string} type - {class\ind}
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings > service type welcome page clicked. Evid: 522.
     * Event description: The visitor received the welcome page where he needs to choose the type of service he wants to book- ind or group. Event sent when clicked (only on group + ind businesses).
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: editor or viewer
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool.
     *
     * biToken - Type: guid.
     *
     * platform - Type: string. Desc: {mobile,pc}
     *
     * type - Type: string. Desc: {class\ind}
     *
     * visitor_id - Type: guid.
     * @param {bookingsServiceTypeWelcomePageClickedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsServiceTypeWelcomePageClicked = function (params) {
        return this.bi.log(__assign({ evid: 522 }, params));
    };
    /**
    * @typedef {Object} bookingsPaymentsChooseProviderPopupParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {string} catId - null
    * @property {GUID} contactId - null
    * @property {string} currency - service booked currency
    * @property {boolean} is_over_editor - editor or viewer
    * @property {boolean} is_owner - is_owner
    * @property {GUID} biToken - null
    * @property {number} numParticipants - num participants chosen
    * @property {string} options - json that holds all the options
    * @property {string} platform - {mobile,pc}
    * @property {number} price - Multiplied
    * @property {string} price_selection - -
    * @property {string} serviceId - -
    * @property {string} type - {class\ind}
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings > payments>choose provider popup. Evid: 525.
     * Event description: payment method selection popup open - sent every time the popup is opened http://prntscr.com/f9cn5w.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * catId - Type: string.
     *
     * contactId - Type: guid.
     *
     * currency - Type: string. Desc: service booked currency
     *
     * is_over_editor - Type: bool. Desc: editor or viewer
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * biToken - Type: guid.
     *
     * numParticipants - Type: numeric. Desc: num participants chosen
     *
     * options - Type: string. Desc: json that holds all the options
     *
     * platform - Type: string. Desc: {mobile,pc}
     *
     * price - Type: numeric. Desc: Multiplied
     *
     * price_selection - Type: string. Desc: -
     *
     * serviceId - Type: string. Desc: -
     *
     * type - Type: string. Desc: {class\ind}
     *
     * visitor_id - Type: guid.
     * @param {bookingsPaymentsChooseProviderPopupParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsPaymentsChooseProviderPopup = function (params) {
        return this.bi.log(__assign({ evid: 525 }, params));
    };
    /**
    * @typedef {Object} bookingsClickOnBookAServiceButtonAfterMembershipPaymentParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - business_id
    * @property {GUID} contactId - contact_id
    * @property {boolean} is_over_editor - editor or viewer
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - null
    * @property {GUID} biToken - msid
    * @property {GUID} site_member_id - site_member_id - member
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: bookings > click on "Book a service" button after membership payment. Evid: 568.
     * Event description: bookings > click on the button after membership payment.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid. Desc: business_id
     *
     * contactId - Type: guid. Desc: contact_id
     *
     * is_over_editor - Type: bool. Desc: editor or viewer
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool.
     *
     * biToken - Type: guid. Desc: msid
     *
     * site_member_id - Type: guid. Desc: site_member_id - member
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {bookingsClickOnBookAServiceButtonAfterMembershipPaymentParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsClickOnBookAServiceButtonAfterMembershipPayment = function (params) {
        return this.bi.log(__assign({ evid: 568 }, params));
    };
    /**
    * @typedef {Object} bookingsPaymentMethodSelectionNextClickedParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {string} errorReason - <error reason>
    * @property {boolean} is_over_editor - -
    * @property {boolean} is_owner - is_owner
    * @property {GUID} biToken - null
    * @property {string} referralInfo - {calendar, booking form}
    * @property {string} serviceId - -
    * @property {boolean} smsNotificationRequest - TRUE if uou sms notification was requested. FALSE if not
    * @property {GUID} staffId - staff_id
    * @property {string} timeslot - session start time
    * @property {string} type - <service type>
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings > next book .click .fail. Evid: 518.
     * Event description: UoU click on "next" in the bookings funnel - but got an error and couldn't continue (e.g., missing field in the form).
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * errorReason - Type: string. Desc: <error reason>
     *
     * is_over_editor - Type: bool. Desc: -
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * biToken - Type: guid.
     *
     * referralInfo - Type: string. Desc: {calendar, booking form}
     *
     * serviceId - Type: string. Desc: -
     *
     * smsNotificationRequest - Type: bool. Desc: TRUE if uou sms notification was requested. FALSE if not
     *
     * staffId - Type: guid. Desc: staff_id
     *
     * timeslot - Type: string. Desc: session start time
     *
     * type - Type: string. Desc: <service type>
     *
     * visitor_id - Type: guid.
     * @param {bookingsPaymentMethodSelectionNextClickedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsPaymentMethodSelectionNextClicked = function (params) {
        return this.bi.log(__assign({ evid: 518 }, params));
    };
    /**
    * @typedef {Object} bookingsTimeTableNavigationParams
    * @property {string} additionalInfo - date presented
    * @property {string} bookingsPlatform - null or new_bookings_platform for new server
    * @property {GUID} businessId - business_id
    * @property {GUID} contactId - contact_id
    * @property {string} direction - {backward,forward}
    * @property {boolean} isEmptyState - true  = empty state
    * @property {boolean} is_over_editor - -
    * @property {boolean} is_owner - is_owner
    * @property {GUID} biToken - msid
    * @property {string} navType - {day,week}
    * @property {string} type - {arrow, date}
    * @property {GUID} visitor_id - visitor_id
    * @property {string} widget_name - {daily_time_table, weekly_time_table}
    **/
    /**
     * Name: bookings > time table navigation. Evid: 579.
     * Event description: Navigating between different days or weeks.
    https://prnt.sc/p0r1ux.
    
     * additionalInfo - Type: string. Desc: date presented
     *
     * bookingsPlatform - Type: string. Desc: null or new_bookings_platform for new server
     *
     * businessId - Type: guid. Desc: business_id
     *
     * contactId - Type: guid. Desc: contact_id
     *
     * direction - Type: string. Desc: {backward,forward}
     *
     * isEmptyState - Type: bool. Desc: true  = empty state
     *
     * is_over_editor - Type: bool. Desc: -
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * biToken - Type: guid. Desc: msid
     *
     * navType - Type: string. Desc: {day,week}
     *
     * type - Type: string. Desc: {arrow, date}
     *
     * visitor_id - Type: guid. Desc: visitor_id
     *
     * widget_name - Type: string. Desc: {daily_time_table, weekly_time_table}
     * @param {bookingsTimeTableNavigationParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsTimeTableNavigation = function (params) {
        return this.bi.log(__assign({ evid: 579 }, params));
    };
    /**
    * @typedef {Object} bookingsOpenFullMonthViewParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - -
    * @property {boolean} is_owner - is_owner
    * @property {GUID} biToken - null
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings > open full month view. Evid: 520.
     * Event description: NEED TO DELETE.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: -
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * biToken - Type: guid.
     *
     * visitor_id - Type: guid.
     * @param {bookingsOpenFullMonthViewParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsOpenFullMonthView = function (params) {
        return this.bi.log(__assign({ evid: 520 }, params));
    };
    /**
    * @typedef {Object} bookingsNextContactInfoParams
    * @property {boolean} address_empty - -
    * @property {boolean} apartment_empty - -
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {boolean} city_empty - -
    * @property {GUID} contactId - null
    * @property {boolean} email_empty - -
    * @property {boolean} full_name_empty - -
    * @property {boolean} is_over_editor - -
    * @property {boolean} is_owner - is_owner
    * @property {GUID} biToken - null
    * @property {boolean} phone_number_empty - -
    * @property {string} platform - {mobile,pc}
    * @property {string} type - {class\ind}
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings > next contact info. Evid: 507.
     * Event description: NEED TO DELETE.
    
     * address_empty - Type: bool. Desc: -
     *
     * apartment_empty - Type: bool. Desc: -
     *
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * city_empty - Type: bool. Desc: -
     *
     * contactId - Type: guid.
     *
     * email_empty - Type: bool. Desc: -
     *
     * full_name_empty - Type: bool. Desc: -
     *
     * is_over_editor - Type: bool. Desc: -
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * biToken - Type: guid.
     *
     * phone_number_empty - Type: bool. Desc: -
     *
     * platform - Type: string. Desc: {mobile,pc}
     *
     * type - Type: string. Desc: {class\ind}
     *
     * visitor_id - Type: guid.
     * @param {bookingsNextContactInfoParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsNextContactInfo = function (params) {
        return this.bi.log(__assign({ evid: 507 }, params));
    };
    /**
    * @typedef {Object} bookingsTestsExposureEventParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - -
    * @property {GUID} contactId - null
    * @property {boolean} is_eligible - true/false
    * @property {GUID} biToken - -
    * @property {string} postreg_category - postreg_category
    * @property {string} testName - test name
    * @property {string} triggerName - exposure point name
    * @property {GUID} uuid - uuid if it's user test, else null
    * @property {GUID} visitorId - visitorId if it's uou test, else null
    * @property {GUID} visitor_id - null
    * @property {string} widget_name - widget_name
    **/
    /**
     * Name: Bookings --> tests exposure event. Evid: 666.
     * Event description: test exposure event for bookings tests.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid. Desc: -
     *
     * contactId - Type: guid.
     *
     * is_eligible - Type: bool. Desc: true/false
     *
     * biToken - Type: guid. Desc: -
     *
     * postreg_category - Type: string. Desc: postreg_category
     *
     * testName - Type: string. Desc: test name
     *
     * triggerName - Type: string. Desc: exposure point name
     *
     * uuid - Type: guid. Desc: uuid if it's user test, else null
     *
     * visitorId - Type: guid. Desc: visitorId if it's uou test, else null
     *
     * visitor_id - Type: guid.
     *
     * widget_name - Type: string. Desc: widget_name
     * @param {bookingsTestsExposureEventParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsTestsExposureEvent = function (params) {
        return this.bi.log(__assign({ evid: 666 }, params));
    };
    /**
    * @typedef {Object} bookingsLoginUserAccountAppointmentsRescheduleClickParams
    * @property {GUID} appointmentId - appointment rescheduled
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - null
    * @property {GUID} biToken - null
    * @property {string} referralinfo - {upcoming}
    * @property {string} serviceid - service rescheduled
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings >login. user account > appointments> reschedule.click. Evid: 546.
     * Event description: on the user account (myaccount) page > appointments tab - click on reschedule appointment http://prntscr.com/dq9z2z.
    
     * appointmentId - Type: guid. Desc: appointment rescheduled
     *
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool.
     *
     * biToken - Type: guid.
     *
     * referralinfo - Type: string. Desc: {upcoming}
     *
     * serviceid - Type: string. Desc: service rescheduled
     *
     * visitor_id - Type: guid.
     * @param {bookingsLoginUserAccountAppointmentsRescheduleClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsLoginUserAccountAppointmentsRescheduleClick = function (params) {
        return this.bi.log(__assign({ evid: 546 }, params));
    };
    /**
    * @typedef {Object} bookingsCantBookGroupsMessageParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - editor or viewer
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - null
    * @property {GUID} biToken - null
    * @property {string} referralInfo - {NULL- service list, service_page}
    * @property {GUID} visitor_id - null
    * @property {string} widget_name - widget phase name
    **/
    /**
     * Name: bookings >cant_book_groups_message. Evid: 527.
     * Event description: The visitor received the 'Sorry, this service can’t be booked online just yet. Please get in touch' message..
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: editor or viewer
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool.
     *
     * biToken - Type: guid.
     *
     * referralInfo - Type: string. Desc: {NULL- service list, service_page}
     *
     * visitor_id - Type: guid.
     *
     * widget_name - Type: string. Desc: widget phase name
     * @param {bookingsCantBookGroupsMessageParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsCantBookGroupsMessage = function (params) {
        return this.bi.log(__assign({ evid: 527 }, params));
    };
    /**
    * @typedef {Object} bookingsClientVmRequestUouParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {GUID} biToken - null
    * @property {string} requestedArea - requested vm {owner,settings,widget}
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings >client vm request - UoU. Evid: 545.
     * Event description: -.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * biToken - Type: guid.
     *
     * requestedArea - Type: string. Desc: requested vm {owner,settings,widget}
     *
     * visitor_id - Type: guid.
     * @param {bookingsClientVmRequestUouParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsClientVmRequestUou = function (params) {
        return this.bi.log(__assign({ evid: 545 }, params));
    };
    /**
    * @typedef {Object} bookingsConnectPaymentProviderNotAvailableOnPreviewPopupParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - -
    * @property {GUID} contactId - null
    * @property {boolean} isPreview - null
    * @property {GUID} biToken - -
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings > connect payment provider not available on preview. popup. Evid: 564.
     * Event description: popup appears - http://prntscr.com/gbmeky.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid. Desc: -
     *
     * contactId - Type: guid.
     *
     * isPreview - Type: bool.
     *
     * biToken - Type: guid. Desc: -
     *
     * visitor_id - Type: guid.
     * @param {bookingsConnectPaymentProviderNotAvailableOnPreviewPopupParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsConnectPaymentProviderNotAvailableOnPreviewPopup = function (params) {
        return this.bi.log(__assign({ evid: 564 }, params));
    };
    /**
    * @typedef {Object} bookingsChangeParticipantsQuantityParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - editor or viewer
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - null
    * @property {GUID} biToken - null
    * @property {number} numParticipants - -
    * @property {string} serviceId - -
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings > change participants quantity. Evid: 533.
     * Event description: change participants quantity in the visitor info page  - sent only when changed previous selection
    http://prntscr.com/bjzc2t.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: editor or viewer
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool.
     *
     * biToken - Type: guid.
     *
     * numParticipants - Type: numeric. Desc: -
     *
     * serviceId - Type: string. Desc: -
     *
     * visitor_id - Type: guid.
     * @param {bookingsChangeParticipantsQuantityParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsChangeParticipantsQuantity = function (params) {
        return this.bi.log(__assign({ evid: 533 }, params));
    };
    /**
    * @typedef {Object} bookingsAddAnotherParticipantClickPhase2Params
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - editor or viewer
    * @property {boolean} is_owner - is_owner
    * @property {GUID} biToken - null
    * @property {string} serviceId - -
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings > add another participant .click - phase 2. Evid: 534.
     * Event description: click on add another participant
    http://prntscr.com/bjzatv.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: editor or viewer
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * biToken - Type: guid.
     *
     * serviceId - Type: string. Desc: -
     *
     * visitor_id - Type: guid.
     * @param {bookingsAddAnotherParticipantClickPhase2Params} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsAddAnotherParticipantClickPhase2 = function (params) {
        return this.bi.log(__assign({ evid: 534 }, params));
    };
    /**
    * @typedef {Object} bookingsSaveAnotherParticipantPhase2Params
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - editor or viewer
    * @property {boolean} is_owner - is_owner
    * @property {GUID} biToken - null
    * @property {number} numParticipants - beside this one
    * @property {string} saveType - {new, edit}
    * @property {string} serviceId - -
    * @property {boolean} success - T=success, F= fail
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings > save another participant - phase 2. Evid: 535.
     * Event description: click on save when adding another participants
    http://prntscr.com/bjzeny.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: editor or viewer
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * biToken - Type: guid.
     *
     * numParticipants - Type: numeric. Desc: beside this one
     *
     * saveType - Type: string. Desc: {new, edit}
     *
     * serviceId - Type: string. Desc: -
     *
     * success - Type: bool. Desc: T=success, F= fail
     *
     * visitor_id - Type: guid.
     * @param {bookingsSaveAnotherParticipantPhase2Params} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsSaveAnotherParticipantPhase2 = function (params) {
        return this.bi.log(__assign({ evid: 535 }, params));
    };
    /**
    * @typedef {Object} bookingsSwitchServiceTypeClickedParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - editor or viewer
    * @property {boolean} is_owner - is_owner
    * @property {GUID} biToken - null
    * @property {string} platform - {mobile,pc}
    * @property {string} switchToType - {class\ind}
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings > switch service type clicked. Evid: 523.
     * Event description: Click on the button on the top right- switch service type (only on group + ind businesses)..
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: editor or viewer
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * biToken - Type: guid.
     *
     * platform - Type: string. Desc: {mobile,pc}
     *
     * switchToType - Type: string. Desc: {class\ind}
     *
     * visitor_id - Type: guid.
     * @param {bookingsSwitchServiceTypeClickedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsSwitchServiceTypeClicked = function (params) {
        return this.bi.log(__assign({ evid: 523 }, params));
    };
    /**
    * @typedef {Object} bookingsTimeZoneShowParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - editor or viewer
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - null
    * @property {GUID} biToken - null
    * @property {string} serviceId - -
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings > time zone. show. Evid: 539.
     * Event description: open time zone popup  -http://prntscr.com/c781mm.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: editor or viewer
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool.
     *
     * biToken - Type: guid.
     *
     * serviceId - Type: string. Desc: -
     *
     * visitor_id - Type: guid.
     * @param {bookingsTimeZoneShowParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsTimeZoneShow = function (params) {
        return this.bi.log(__assign({ evid: 539 }, params));
    };
    /**
    * @typedef {Object} bookingsSelectPricingPlanParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - business_id
    * @property {string} catId - category id
    * @property {GUID} contactId - contact_id
    * @property {string} currency - currency
    * @property {boolean} is_over_editor - is_over_editor
    * @property {boolean} is_owner - is_owner
    * @property {GUID} biToken - msid
    * @property {GUID} paid_plan_id - paid_plan_id
    * @property {string} paid_plan_name - paid_plan_name
    * @property {number} paid_plan_price - paid_plan_price
    * @property {string} paid_plan_valid_for - paid_plan_valid_for (3/4/5 months/1 year/custom)
    * @property {string} paymentMethod - payment_type
    * @property {string} platform - platform
    * @property {string} referal_info - referal_info
    * @property {string} serviceId - service_id
    * @property {GUID} site_member_id - site_member_id - logged user
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: bookings > select pricing plan. Evid: 566.
     * Event description: select pricing plan.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid. Desc: business_id
     *
     * catId - Type: string. Desc: category id
     *
     * contactId - Type: guid. Desc: contact_id
     *
     * currency - Type: string. Desc: currency
     *
     * is_over_editor - Type: bool. Desc: is_over_editor
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * biToken - Type: guid. Desc: msid
     *
     * paid_plan_id - Type: guid. Desc: paid_plan_id
     *
     * paid_plan_name - Type: string. Desc: paid_plan_name
     *
     * paid_plan_price - Type: numeric. Desc: paid_plan_price
     *
     * paid_plan_valid_for - Type: string. Desc: paid_plan_valid_for (3/4/5 months/1 year/custom)
     *
     * paymentMethod - Type: string. Desc: payment_type
     *
     * platform - Type: string. Desc: platform
     *
     * referal_info - Type: string. Desc: referal_info
     *
     * serviceId - Type: string. Desc: service_id
     *
     * site_member_id - Type: guid. Desc: site_member_id - logged user
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {bookingsSelectPricingPlanParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsSelectPricingPlan = function (params) {
        return this.bi.log(__assign({ evid: 566 }, params));
    };
    /**
    * @typedef {Object} bookingsPaymentsCashierChoosePaymentMethodPopupParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {GUID} biToken - null
    * @property {string} serviceId - -
    * @property {string} type - {class\ind}
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings > payments> Cashier>choose payment method popup. Evid: 554.
     * Event description: http://prntscr.com/ehvti0.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * biToken - Type: guid.
     *
     * serviceId - Type: string. Desc: -
     *
     * type - Type: string. Desc: {class\ind}
     *
     * visitor_id - Type: guid.
     * @param {bookingsPaymentsCashierChoosePaymentMethodPopupParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsPaymentsCashierChoosePaymentMethodPopup = function (params) {
        return this.bi.log(__assign({ evid: 554 }, params));
    };
    /**
    * @typedef {Object} bookingsTimeZoneInfoParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - -
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - null
    * @property {GUID} biToken - null
    * @property {string} ownerOffset - -
    * @property {string} ownerTimeZone - -
    * @property {GUID} visitor_id - null
    * @property {string} visitorOffset - -
    * @property {string} visitorTimeZone - -
    **/
    /**
     * Name: bookings > time zone info. Evid: 532.
     * Event description: sends time zone information when calendar page is opened.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: -
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool.
     *
     * biToken - Type: guid.
     *
     * ownerOffset - Type: string. Desc: -
     *
     * ownerTimeZone - Type: string. Desc: -
     *
     * visitor_id - Type: guid.
     *
     * visitorOffset - Type: string. Desc: -
     *
     * visitorTimeZone - Type: string. Desc: -
     * @param {bookingsTimeZoneInfoParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsTimeZoneInfo = function (params) {
        return this.bi.log(__assign({ evid: 532 }, params));
    };
    /**
    * @typedef {Object} bookingsAnotherAppointmentParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - -
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - null
    * @property {GUID} biToken - null
    * @property {string} platform - {mobile,pc}
    * @property {string} referralInfo - {upcoming, history, null}
    * @property {string} type - {class\ind}
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings > another appointment. Evid: 512.
     * Event description: another appointment.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: -
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool.
     *
     * biToken - Type: guid.
     *
     * platform - Type: string. Desc: {mobile,pc}
     *
     * referralInfo - Type: string. Desc: {upcoming, history, null}
     *
     * type - Type: string. Desc: {class\ind}
     *
     * visitor_id - Type: guid.
     * @param {bookingsAnotherAppointmentParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsAnotherAppointment = function (params) {
        return this.bi.log(__assign({ evid: 512 }, params));
    };
    /**
    * @typedef {Object} bookingsCalendarDrpodownChangeStaffMemberSelectionParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - editor or viewer
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - null
    * @property {GUID} biToken - null
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings >calendar>drpodown>change_staff_member_selection. Evid: 529.
     * Event description: sent when the UoU change the dropdown filter selection http://prntscr.com/bgni00.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: editor or viewer
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool.
     *
     * biToken - Type: guid.
     *
     * visitor_id - Type: guid.
     * @param {bookingsCalendarDrpodownChangeStaffMemberSelectionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsCalendarDrpodownChangeStaffMemberSelection = function (params) {
        return this.bi.log(__assign({ evid: 529 }, params));
    };
    /**
    * @typedef {Object} bookingsLoginUserAccountPersonalInfoEditClickParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - null
    * @property {GUID} biToken - null
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings >login. user account > personal info> edit.click. Evid: 553.
     * Event description: on the user account (myaccount) page > personal info tab - click on edit http://prntscr.com/e2rey1.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool.
     *
     * biToken - Type: guid.
     *
     * visitor_id - Type: guid.
     * @param {bookingsLoginUserAccountPersonalInfoEditClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsLoginUserAccountPersonalInfoEditClick = function (params) {
        return this.bi.log(__assign({ evid: 553 }, params));
    };
    /**
    * @typedef {Object} bookingsGoogleCalendarParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - -
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - null
    * @property {GUID} biToken - null
    * @property {string} platform - {mobile,pc}
    * @property {string} type - {ind,class}
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings > add booked service to calendar. Evid: 513.
     * Event description: google calendar.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: -
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool.
     *
     * biToken - Type: guid.
     *
     * platform - Type: string. Desc: {mobile,pc}
     *
     * type - Type: string. Desc: {ind,class}
     *
     * visitor_id - Type: guid.
     * @param {bookingsGoogleCalendarParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsGoogleCalendar = function (params) {
        return this.bi.log(__assign({ evid: 513 }, params));
    };
    /**
    * @typedef {Object} bookingsWaitlistStatusParams
    * @property {string} additionalInfo - general description
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - -
    * @property {GUID} contactId - -
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - -
    * @property {GUID} biToken - -
    * @property {string} platform - {mobile,pc}
    * @property {string} referralInfo - {NULL= regular, widget, members_area_upcoming, members_area_history, one_app_main_tab, one_app_all_classes, one_app_all_appointments, one_app_agenda, session page}
    * @property {string} service_id - -
    * @property {string} status - join/leave
    * @property {string} type - {class\ind}
    * @property {GUID} visitor_id - -
    **/
    /**
     * Name: bookings > waitlist action. Evid: 581.
     * Event description: waitlist status - sent once a user joins or leaves a waiting list.
    
     * additionalInfo - Type: string. Desc: general description
     *
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid. Desc: -
     *
     * contactId - Type: guid. Desc: -
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool. Desc: -
     *
     * biToken - Type: guid. Desc: -
     *
     * platform - Type: string. Desc: {mobile,pc}
     *
     * referralInfo - Type: string. Desc: {NULL= regular, widget, members_area_upcoming, members_area_history, one_app_main_tab, one_app_all_classes, one_app_all_appointments, one_app_agenda, session page}
     *
     * service_id - Type: string. Desc: -
     *
     * status - Type: string. Desc: join/leave
     *
     * type - Type: string. Desc: {class\ind}
     *
     * visitor_id - Type: guid. Desc: -
     * @param {bookingsWaitlistStatusParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsWaitlistStatus = function (params) {
        return this.bi.log(__assign({ evid: 581 }, params));
    };
    /**
    * @typedef {Object} bookingsApplyPromoCodeParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - business_id
    * @property {GUID} contactId - contact_id
    * @property {boolean} is_over_editor - -
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - is_preview
    * @property {GUID} biToken - msid
    * @property {string} type - service type {class\ind\course}
    * @property {string} valid_value - {ok/expired/invalid}
    * @property {GUID} visitor_id - visitor id
    **/
    /**
     * Name: bookings > apply promo code. Evid: 572.
     * Event description: Apply promo code after entering it.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid. Desc: business_id
     *
     * contactId - Type: guid. Desc: contact_id
     *
     * is_over_editor - Type: bool. Desc: -
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool. Desc: is_preview
     *
     * biToken - Type: guid. Desc: msid
     *
     * type - Type: string. Desc: service type {class\ind\course}
     *
     * valid_value - Type: string. Desc: {ok/expired/invalid}
     *
     * visitor_id - Type: guid. Desc: visitor id
     * @param {bookingsApplyPromoCodeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsApplyPromoCode = function (params) {
        return this.bi.log(__assign({ evid: 572 }, params));
    };
    /**
    * @typedef {Object} bookingsBookItClickParams
    * @property {boolean} accept_online_bookings - FALSE only if this a "no book flow"
    * @property {string} actionName - {navigate_to_contact_form,navigate_to_service_page,open_waiting_list_modal,open_uou_premium_modal,open_owner_premium_modal,navigate_to_specific_page,navigate_to_services_list}
    * @property {boolean} bookAnotherLogged - T=http://prntscr.com/dqa17x, NULL/F=regular
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_membership - 1 if the service is part of membership
    * @property {boolean} is_over_editor - editor or viewer
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPendingApproval - is_pending_approval indication
    * @property {boolean} isPreview - null
    * @property {boolean} logged - T= logged in, F= not
    * @property {GUID} biToken - null
    * @property {string} offered_as - How is this service offered to uou (single, pricing plan, both)
    * @property {string} platform - {mobile,pc}
    * @property {number} price - Multiplied
    * @property {string} referralInfo - {NULL= regular, widget,service page, members_area_upcoming, members_area_history, one_app_main_tab, one_app_all_classes, one_app_all_appointments, one_app_agenda, widget_more_info_label,book_button_widget,staff_widget}
    * @property {string} section - -
    * @property {string} service_id - -
    * @property {string} type - {class\ind}
    * @property {GUID} visitor_id - null
    * @property {string} widget_name - widget version
    **/
    /**
     * Name: bookings > book it click. Evid: 501.
     * Event description: book it click - sent also from image/service name/description/learn more/read more.
    
     * accept_online_bookings - Type: bool. Desc: FALSE only if this a "no book flow"
     *
     * actionName - Type: string. Desc: {navigate_to_contact_form,navigate_to_service_page,open_waiting_list_modal,open_uou_premium_modal,open_owner_premium_modal,navigate_to_specific_page,navigate_to_services_list}
     *
     * bookAnotherLogged - Type: bool. Desc: T=http://prntscr.com/dqa17x, NULL/F=regular
     *
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_membership - Type: bool. Desc: 1 if the service is part of membership
     *
     * is_over_editor - Type: bool. Desc: editor or viewer
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPendingApproval - Type: bool. Desc: is_pending_approval indication
     *
     * isPreview - Type: bool.
     *
     * logged - Type: bool. Desc: T= logged in, F= not
     *
     * biToken - Type: guid.
     *
     * offered_as - Type: string. Desc: How is this service offered to uou (single, pricing plan, both)
     *
     * platform - Type: string. Desc: {mobile,pc}
     *
     * price - Type: numeric. Desc: Multiplied
     *
     * referralInfo - Type: string. Desc: {NULL= regular, widget,service page, members_area_upcoming, members_area_history, one_app_main_tab, one_app_all_classes, one_app_all_appointments, one_app_agenda, widget_more_info_label,book_button_widget,staff_widget}
     *
     * section - Type: string. Desc: -
     *
     * service_id - Type: string. Desc: -
     *
     * type - Type: string. Desc: {class\ind}
     *
     * visitor_id - Type: guid.
     *
     * widget_name - Type: string. Desc: widget version
     * @param {bookingsBookItClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsBookItClick = function (params) {
        return this.bi.log(__assign({ evid: 501 }, params));
    };
    /**
    * @typedef {Object} bookingsChooseTimeSlotParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - -
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - null
    * @property {boolean} isWaitingList - true/false according to the indicator
    * @property {GUID} biToken - null
    * @property {string} origin - optional - timetable_widget
    * @property {string} platform - {mobile,pc}
    * @property {boolean} reschedule - T=is reschedule F= regular
    * @property {string} type - {class\ind}
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings > choose time slot. Evid: 506.
     * Event description: choose time slot.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: -
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool.
     *
     * isWaitingList - Type: bool. Desc: true/false according to the indicator
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: optional - timetable_widget
     *
     * platform - Type: string. Desc: {mobile,pc}
     *
     * reschedule - Type: bool. Desc: T=is reschedule F= regular
     *
     * type - Type: string. Desc: {class\ind}
     *
     * visitor_id - Type: guid.
     * @param {bookingsChooseTimeSlotParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsChooseTimeSlot = function (params) {
        return this.bi.log(__assign({ evid: 506 }, params));
    };
    /**
    * @typedef {Object} bookingsAccountActivityUserClickParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - editor or viewer
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - null
    * @property {GUID} biToken - null
    * @property {string} pageName - {service_list, calendar...}
    * @property {string} service_id - NOT SENT
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings > Account Activity > user click. Evid: 544.
     * Event description: http://prntscr.com/d6ntxz.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: editor or viewer
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool.
     *
     * biToken - Type: guid.
     *
     * pageName - Type: string. Desc: {service_list, calendar...}
     *
     * service_id - Type: string. Desc: NOT SENT
     *
     * visitor_id - Type: guid.
     * @param {bookingsAccountActivityUserClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsAccountActivityUserClick = function (params) {
        return this.bi.log(__assign({ evid: 544 }, params));
    };
    /**
    * @typedef {Object} jsErrorParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} isPreview - null
    * @property {GUID} biToken - null
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: js_error. Evid: 524.
     * Event description: this event is sent every time a java script error occurs- for user explorer research (dev request - Boris).
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * isPreview - Type: bool.
     *
     * biToken - Type: guid.
     *
     * visitor_id - Type: guid.
     * @param {jsErrorParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.jsError = function (params) {
        return this.bi.log(__assign({ evid: 524 }, params));
    };
    /**
    * @typedef {Object} bookingsClickOnGotItButtonAfterMembershipOrderParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - business_id
    * @property {GUID} contactId - contact_id
    * @property {boolean} is_over_editor - editor or viewer
    * @property {boolean} is_owner - is_owner
    * @property {GUID} biToken - msid
    * @property {GUID} site_member_id - site_member_id - member
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: Paid plans > click on "Got it" button after membership order. Evid: 569.
     * Event description: Not relevant - will be sent from the Paid plans side.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid. Desc: business_id
     *
     * contactId - Type: guid. Desc: contact_id
     *
     * is_over_editor - Type: bool. Desc: editor or viewer
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * biToken - Type: guid. Desc: msid
     *
     * site_member_id - Type: guid. Desc: site_member_id - member
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {bookingsClickOnGotItButtonAfterMembershipOrderParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsClickOnGotItButtonAfterMembershipOrder = function (params) {
        return this.bi.log(__assign({ evid: 569 }, params));
    };
    /**
    * @typedef {Object} bookingsAppointmentBookedServerIssueParams
    * @property {string} bookingId - -
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - -
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - editor or viewer
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - null
    * @property {GUID} biToken - -
    * @property {string} service - [type of service]
    * @property {string} status - {valid, invalid online, invalid offline}
    * @property {string} sub_category - [why status fail]
    * @property {string} transaction - {book new, reschedule}
    * @property {GUID} visitor_id - -
    **/
    /**
     * Name: bookings > appointment booked server issue. Evid: 565.
     * Event description: sent with the appointment booked event to detect failure, if exist.
    
     * bookingId - Type: string. Desc: -
     *
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid. Desc: -
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: editor or viewer
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool.
     *
     * biToken - Type: guid. Desc: -
     *
     * service - Type: string. Desc: [type of service]
     *
     * status - Type: string. Desc: {valid, invalid online, invalid offline}
     *
     * sub_category - Type: string. Desc: [why status fail]
     *
     * transaction - Type: string. Desc: {book new, reschedule}
     *
     * visitor_id - Type: guid. Desc: -
     * @param {bookingsAppointmentBookedServerIssueParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsAppointmentBookedServerIssue = function (params) {
        return this.bi.log(__assign({ evid: 565 }, params));
    };
    /**
    * @typedef {Object} bookingsCoursePageViewFullScheduleClickParams
    * @property {string} bookingsPlatform - new_bookings_platform
    * @property {GUID} businessId - -
    * @property {GUID} contactId - null
    * @property {GUID} biToken - -
    * @property {string} origin - member_course_page
    * @property {string} serviceId - -
    * @property {string} type - course
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings > OneApp > course page > view full schedule click. Evid: 583.
     * Event description: member - https://zpl.io/aR5MAez.
    
     * bookingsPlatform - Type: string. Desc: new_bookings_platform
     *
     * businessId - Type: guid. Desc: -
     *
     * contactId - Type: guid.
     *
     * biToken - Type: guid. Desc: -
     *
     * origin - Type: string. Desc: member_course_page
     *
     * serviceId - Type: string. Desc: -
     *
     * type - Type: string. Desc: course
     *
     * visitor_id - Type: guid.
     * @param {bookingsCoursePageViewFullScheduleClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsCoursePageViewFullScheduleClick = function (params) {
        return this.bi.log(__assign({ evid: 583 }, params));
    };
    /**
    * @typedef {Object} bookingsMemberLoginSignoutClickParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - editor or viewer
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - null
    * @property {GUID} biToken - null
    * @property {string} pageName - {service_list,calendar,personal_info...}
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings >member login. signout click. Evid: 552.
     * Event description: click on signout.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: editor or viewer
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool.
     *
     * biToken - Type: guid.
     *
     * pageName - Type: string. Desc: {service_list,calendar,personal_info...}
     *
     * visitor_id - Type: guid.
     * @param {bookingsMemberLoginSignoutClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsMemberLoginSignoutClick = function (params) {
        return this.bi.log(__assign({ evid: 552 }, params));
    };
    /**
    * @typedef {Object} bookingsChangeTimeZoneClickedParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {string} changeTo - {local,business time zone}
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - editor or viewer
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - null
    * @property {GUID} biToken - null
    * @property {string} referralInfo - {calendar,offering_page, service_page}
    * @property {string} serviceId - -
    * @property {string} timezone - -
    * @property {string} type - {class\ind\course}
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings > change time zone.clicked. Evid: 538.
     * Event description: convert time zone- http://prntscr.com/c780rd.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * changeTo - Type: string. Desc: {local,business time zone}
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: editor or viewer
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool.
     *
     * biToken - Type: guid.
     *
     * referralInfo - Type: string. Desc: {calendar,offering_page, service_page}
     *
     * serviceId - Type: string. Desc: -
     *
     * timezone - Type: string. Desc: -
     *
     * type - Type: string. Desc: {class\ind\course}
     *
     * visitor_id - Type: guid.
     * @param {bookingsChangeTimeZoneClickedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsChangeTimeZoneClicked = function (params) {
        return this.bi.log(__assign({ evid: 538 }, params));
    };
    /**
    * @typedef {Object} bookingsLoginUserAccountAppointmentsMoreDetailsServiceClickParams
    * @property {string} appointmentId - appointment more info
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - -
    * @property {GUID} contactId - -
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPendingApproval - T/F for pending approval service
    * @property {GUID} biToken - -
    * @property {string} referralinfo - {upcoming, history}
    * @property {string} serviceid - service more info
    * @property {GUID} visitor_id - -
    **/
    /**
     * Name: bookings >login. user account > appointments> more details service.click. Evid: 561.
     * Event description: on the user account (members area - my bookings) page > upcoming/history tab - click on service line https://prnt.sc/gscdqf.
    
     * appointmentId - Type: string. Desc: appointment more info
     *
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid. Desc: -
     *
     * contactId - Type: guid. Desc: -
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPendingApproval - Type: bool. Desc: T/F for pending approval service
     *
     * biToken - Type: guid. Desc: -
     *
     * referralinfo - Type: string. Desc: {upcoming, history}
     *
     * serviceid - Type: string. Desc: service more info
     *
     * visitor_id - Type: guid. Desc: -
     * @param {bookingsLoginUserAccountAppointmentsMoreDetailsServiceClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsLoginUserAccountAppointmentsMoreDetailsServiceClick = function (params) {
        return this.bi.log(__assign({ evid: 561 }, params));
    };
    /**
    * @typedef {Object} bookingsMoreParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - -
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - null
    * @property {GUID} biToken - null
    * @property {string} service_id - -
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings > more. Evid: 502.
     * Event description: Cancelled.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: -
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool.
     *
     * biToken - Type: guid.
     *
     * service_id - Type: string. Desc: -
     *
     * visitor_id - Type: guid.
     * @param {bookingsMoreParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsMore = function (params) {
        return this.bi.log(__assign({ evid: 502 }, params));
    };
    /**
    * @typedef {Object} bookingsCancelOrBackParams
    * @property {string} bookingsPlatform - null
    * @property {GUID} businessId - null
    * @property {GUID} contactId - null
    * @property {boolean} is_over_editor - -
    * @property {boolean} is_owner - is_owner
    * @property {boolean} isPreview - null
    * @property {GUID} biToken - null
    * @property {string} platform - {mobile,pc}
    * @property {string} referal_info - {date&time, contact_info,Confirmation}
    * @property {string} type - {class\ind}
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: bookings > cancel or back. Evid: 510.
     * Event description: cancel or back.
    
     * bookingsPlatform - Type: string.
     *
     * businessId - Type: guid.
     *
     * contactId - Type: guid.
     *
     * is_over_editor - Type: bool. Desc: -
     *
     * is_owner - Type: bool. Desc: is_owner
     *
     * isPreview - Type: bool.
     *
     * biToken - Type: guid.
     *
     * platform - Type: string. Desc: {mobile,pc}
     *
     * referal_info - Type: string. Desc: {date&time, contact_info,Confirmation}
     *
     * type - Type: string. Desc: {class\ind}
     *
     * visitor_id - Type: guid.
     * @param {bookingsCancelOrBackParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.bookingsCancelOrBack = function (params) {
        return this.bi.log(__assign({ evid: 510 }, params));
    };
    return Logger;
}());
exports.Logger = Logger;
exports.default = init;
function getLoggerConf() {
    return {
        src: 16,
        endpoint: 'wixboost-ugc'
    };
}
exports.getLoggerConf = getLoggerConf;
//# sourceMappingURL=index.js.map